<div class="p-grid" style="margin: 15px">
    <p-panel header="UTILISATEURS ENREGISTRES" class="p-col-12" styleClass="user-list" >
        <p-table #dt [columns]="tableCols" [value]="userList" styleClass="ui-table-customers" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
            <ng-template pTemplate="caption">
                <div style="text-align: left" class="p-grid">
                    <div class="ui-inputgroup recherche p-col-11" >
                        <span class="ui-inputgroup-addon">Rechercher :</span>
                        <input type="text" pInputText size="37" placeholder="Filtre globale" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto; min-height:35px;">
                    </div>
                    <p-button [style]="{'float':'right'}" type="button" class="btn-modif p-col-1" icon="pi pi-plus-circle" (click)="showModal()"></p-button>
                </div>

            </ng-template>

            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of tableCols" [pSortableColumn]="col.field">
                        {{col.header}}
                        <p-sortIcon [field]="col.field" ></p-sortIcon>
                    </th>

                    <th style="width: 100px; text-align: center; ">Modifier</th>
                    <th>Réinit. Mdp</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-user let-columns="columns">
                <tr>
                    <td *ngFor="let col of columns">
                        {{user[col.field]}}
                    </td>
                    <td align="center"> <p-button type="button"  class="btn-modif" icon="pi pi-pencil" (click)="showModal(user)"></p-button> </td>
                    <td align="center"> <p-button type="button"  class="btn-modif" icon="pi pi-refresh" (click)="confirmReinit(user)"></p-button> </td>
                </tr>
            </ng-template>
        </p-table>
    </p-panel>

</div>

<app-dialogue-user [is-visible]="modalVisible" (changeVisibleEvent)="modalVisible=$event" [data]="data"></app-dialogue-user>

<p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>